import './PriceHistoryDiff.css';

import React from 'react';

import { CurrencyEnum } from '@search/graphql-typings';
import { formatPrice } from '@search/helpers/src/gql/formatPrice';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'PriceHistoryDiff');

export function PriceHistoryDiff({
    diff
}: {
    diff: number;
}) {
    return (<span
        className={cn(null, { direction: diff < 0 ? 'sub' : 'add' })}
    >
        {`${diff < 0 ? '-' : '+'}\u00A0${
            formatPrice({
                value: Math.abs(diff),
                currency: CurrencyEnum.Rub,
                displayCurrency: true,
                noFractional: true
            })}`}
    </span>);
}
